import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { BlockedIcon } from '../../../../assets/images';
import { THIS_MESSAGE_WAS_DELETED, YOU_DELETED_THIS_MESSAGE } from '../../../../Helpers/Chat/Constant';
import { UserProfileImage, UserProfileName } from '../../../components';
import { getLocalUserDetails } from '../../../utils';
import { useMarkMessageAsRead } from '../../../utils/customHooks/useMarkMessageAsRead';

function DeletedMessage({ channelId, item, index }) {
   const localUser = getLocalUserDetails();
   const isSender = item.senderId === localUser?.userId;
   const deletedMessageText = isSender ? YOU_DELETED_THIS_MESSAGE : THIS_MESSAGE_WAS_DELETED;

   useMarkMessageAsRead(channelId, item, index);

   return (
      <div className="message-text" id={`${item.messageId}_${item.sequenceId}`}>
         <span className="recallstatus deleted_messge text-italic">
            <i>
               <BlockedIcon />
            </i>
            {deletedMessageText}
         </span>
      </div>
   );
}

DeletedMessage.propTypes = {
   channelId: PropTypes.string.isRequired,
   item: PropTypes.shape({
      messageId: PropTypes.string,
      senderId: PropTypes.string,
      messageTime: PropTypes.number,
   }).isRequired,
   index: PropTypes.number.isRequired,
};

export default React.memo(DeletedMessage);

